import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

export const EmptyState = ({ icon: Icon = Inbox, title, description, action, compact = false, className, ...props }) => (
  <div
    className={cn(
      "flex flex-col items-center justify-center rounded-lg border border-dashed border-border bg-card text-center",
      compact ? "px-4 py-8" : "px-6 py-12",
      className,
    )}
    {...props}
  >
    <Icon className={cn("mb-3 text-muted-foreground", compact ? "h-5 w-5" : "h-6 w-6")} strokeWidth={1.5} />
    <p className="text-sm font-semibold">{title}</p>
    {description ? <p className="mt-1 max-w-sm text-sm leading-6 text-muted-foreground">{description}</p> : null}
    {action ? <div className="mt-4">{action}</div> : null}
  </div>
);
